"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.env = exports.Env = void 0;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

/**
 * @file env.js H5 环境判断
 * @module env
 * @date 2019-05-07
 */

/**
 * Env Class
 * @example:
 * // UserAgent info
 * // { "APP_DEVICE_KEY" : "402A3AB6-0F91-4549-B826-11AB131522E8", "JuvenileGet" : "1", "APP_TOKEN" :
 *   "21d9e39c-871a-4401-9fc2-4f66b6ab66bd", "APP_VERSION_NAME" : "1.5.1", "APP_USER" : "12303500001",
 *   "APP_DEVICE_TYPE" : "0", "APP_USER_PID" : "12014655", "AGENT_WEB_VIEW" : "igetios", "OS_INFO" : "iPhone11,6_12.2"}
 *
 * // 新版 UA 内容如下
 * Mozilla/5.0 (iPhone; CPU iPhone OS 12_2 like Mac OS X) AppleWebKit/605.1.15 (KHTML, like Gecko) Mobile/15E148
 *   AppVersion=2.9.0   JuvenileGet 其中追加了： AppVersion=2.9.0   JuvenileGet
 *
 * const env = new Env(navigator.userAgent)
 * env.isApp // true
 * env.appVer // 1.5.1
 */
var Env = /*#__PURE__*/function () {
  function Env() {
    var ua = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.navigator.userAgent;

    _classCallCheck(this, Env);

    // Can not use RegExp global flag
    // App 在 2.8.0 以前(含)会在 UA 中注入以下字段
    var ANDROID_APP_REGEXP = /igetcool/i;
    var SENSORS = /igetcool\.com/i;
    var IOS_APP_REGEXP = /igetios/i; // App 在 2.8.0 以后仅会注入 JuvenileGet

    var APP_REGEXP = /JuvenileGet/i;
    this._isAndroidApp = ANDROID_APP_REGEXP.test(ua) && !SENSORS.test(ua);
    this._isIOSApp = IOS_APP_REGEXP.test(ua);
    this._isApp = APP_REGEXP.test(ua);
    this._isHuawei = ua.toLowerCase().indexOf('huawei') > -1 || ua.toLowerCase().indexOf('honor') > -1;
    this._isWeChat = false;
    this._isQQ = false;
    this._isWeibo = false;
    this._isMiniProgram = window.__wxjs_environment === 'miniprogram';
    var appVer = '';
    this._pid = '';
    this._devKey = '';
    this._devType = '';
    this._osVer = '';

    if (this.isApp) {
      // 老版本 UA 信息，匹配 {} 內的所有內容
      var oldAppRegExp = /{([^{}]*)}/;
      var matches = ua.match(oldAppRegExp);

      if (matches) {
        var confStr = matches[0];
        var confObj = JSON.parse(confStr);
        var _confObj$APP_VERSION_ = confObj.APP_VERSION_NAME,
            ver = _confObj$APP_VERSION_ === void 0 ? '' : _confObj$APP_VERSION_,
            _confObj$APP_USER_PID = confObj.APP_USER_PID,
            pid = _confObj$APP_USER_PID === void 0 ? '' : _confObj$APP_USER_PID,
            _confObj$APP_DEVICE_K = confObj.APP_DEVICE_KEY,
            devKey = _confObj$APP_DEVICE_K === void 0 ? '' : _confObj$APP_DEVICE_K;
        appVer = ver;
        this._pid = pid;
        this._devKey = devKey;
      } else {
        // 新版本 UA 信息，只有 AppVersion 和 JuvenileGet
        var newAppRegExp = /AppVersion=([\d.]+)/;

        var _matches = ua.match(newAppRegExp);

        if (_matches) {
          appVer = _matches[1];
        }
      }
    } else {
      var wx = ua.replace(/^.*MicroMessenger\/([\d.]+).*$/, '$1');
      var qq = ua.replace(/^.*QQ\/([\d.]+).*$/i, '$1');
      var isWX = /^.*MicroMessenger\/([\d.]+).*$/.test(ua);
      var isQQ = /^.*QQ\/([\d.]+).*$/i.test(ua);
      var isWeibo = ua.indexOf('weibo') !== -1;
      this._isWeibo = isWeibo;

      if (isWX) {
        this._isWeChat = true;
        appVer = wx;
      } else if (isQQ) {
        this._isQQ = true;
        appVer = qq;
      }
    }

    this._appVer = appVer; // 判断系统版本及版本号 this._osVer，对于老版 iOS app 无法判断正确版本号，因为 iOS 把原生 UA 覆盖掉了

    this._isAndroid = ua.indexOf('Android') > -1 || ua.indexOf('Adr') > -1 || ua.indexOf('igetcool') > -1 && ua.indexOf('igetcool.com') === -1;
    this._isIOS = ua.indexOf('like Mac OS X') > -1 || ua.indexOf('igetios') > -1;

    if (this._isAndroid) {
      var adrVerRegExp = /^.*Android ([\d.]+);.*$/;

      var _matches2 = ua.match(adrVerRegExp);

      if (_matches2) {
        this._osVer = _matches2[1];
      }

      this._devType = 'Android';
    } else if (this._isIOS) {
      var iOSVerRegExp = /^.*OS ([\d_]+) like.*$/;

      var _matches3 = ua.match(iOSVerRegExp);

      if (_matches3) {
        this._osVer = _matches3[1].replace(/_/g, '.');
      }

      this._devType = 'IOS';
    } else {// 其他系统就不支持了
    } // mobileDeviceType


    var deviceType = '';

    if (/ipad/i.test(ua)) {
      deviceType = 'iPad';
    } else if (/iphone|ipod/i.test(ua)) {
      deviceType = 'iPhone';
    } else if (/android/i.test(ua)) {
      deviceType = 'Android';
    } else {
      deviceType = '';
    }

    this._mobileDeviceType = deviceType;
    var browser = '';

    if (!this._isAndroidApp && !this._isIOSApp) {
      if (ua.indexOf('HUAWEI') > -1) {
        browser = 'HuaWeiDefault';
      } else if (ua.indexOf('HONOR') > -1) {
        browser = 'HONOR';
      } else if (ua.indexOf('UCBrowser') > -1) {
        browser = 'UC';
      } else if (ua.indexOf('Sogou') > -1) {
        // Sogou 浏览器 UA 包含，SogouMSE 和 SogouMobileBrowser. 暂时使用 Sogou 判断。
        browser = 'Sogou';
      } else if (ua.indexOf('Safari') > -1 && ua.indexOf('Chrome') === -1) {
        browser = 'Safari';
      } else if (ua.indexOf('Firefox') > -1) {
        browser = 'FF';
      }

      this._browser = browser;
    }
  }

  _createClass(Env, [{
    key: "browser",
    get: function get() {
      return this._browser;
    }
    /**
     * 是否在少年得到 App 的 WebView 内
     * @returns {boolean}
     */

  }, {
    key: "isApp",
    get: function get() {
      return this._isAndroidApp || this._isIOSApp || this._isApp;
    }
  }, {
    key: "notInApp",
    get: function get() {
      return !this.isApp;
    }
  }, {
    key: "isIOSApp",
    get: function get() {
      return this._isIOSApp || this._isApp && this._isIOS;
    }
  }, {
    key: "isAndroidApp",
    get: function get() {
      return this._isAndroidApp || this._isApp && this._isAndroid;
    }
  }, {
    key: "isWeChat",
    get: function get() {
      return this._isWeChat;
    }
  }, {
    key: "isQQ",
    get: function get() {
      return this._isQQ;
    }
  }, {
    key: "isWeibo",
    get: function get() {
      return this._isWeibo;
    }
  }, {
    key: "isMiniProgram",
    get: function get() {
      return this._isMiniProgram;
    }
    /**
     * 获取所在软件的版本号
     * 例如：QQ 下获取 QQ 版本，微信下获取微信版本，App 下获取 App 的版本
     * 格式 '1.5.1'
     * @return {string}
     */

  }, {
    key: "appVer",
    get: function get() {
      return this._appVer;
    }
    /**
     * App 内的用户 pid，已废弃
     * @returns {string}
     */

  }, {
    key: "userPid",
    get: function get() {
      return this._pid;
    }
    /**
     * App 内设备 key，已废弃
     * @returns {string}
     */

  }, {
    key: "deviceKey",
    get: function get() {
      return this._devKey;
    }
    /**
     * 设备标识，App 内有效。已废弃
     * @deprecated
     * @returns {string}
     */

  }, {
    key: "deviceType",
    get: function get() {
      return this._devType;
    }
    /**
     * 安卓操作系统
     * @returns {boolean|*}
     */

  }, {
    key: "isAndroid",
    get: function get() {
      return this._isAndroid;
    }
    /**
     * iOS 操作系统
     * @returns {boolean|*}
     */

  }, {
    key: "isIOS",
    get: function get() {
      return this._isIOS;
    }
    /**
     * 华为 操作系统
     * @returns {boolean|*}
     */

  }, {
    key: "isHuawei",
    get: function get() {
      return this._isHuawei;
    }
    /**
     * 操作系统版本号
     * @returns {string}
     */

  }, {
    key: "OSVer",
    get: function get() {
      return this._osVer;
    }
  }, {
    key: "OSType",
    get: function get() {
      if (this._isAndroidApp || this._isAndroid) {
        return 'Android';
      } else if (this._isIOSApp || this._isIOS) {
        return 'IOS';
      } else {
        return '';
      }
    }
  }, {
    key: "environment",
    get: function get() {
      if (this.isApp) {
        return 'APP';
      } else if (this.isWeChat) {
        return 'WX';
      } else if (this.isQQ) {
        return 'QQ';
      } else {
        return '';
      }
    }
  }, {
    key: "mobileDeviceType",
    get: function get() {
      return this._mobileDeviceType;
    }
  }]);

  return Env;
}();

exports.Env = Env;
var env = new Env();
exports.env = env;